import { render } from "./EventsView.vue?vue&type=template&id=ececc76c&ts=true"
import script from "./EventsView.vue?vue&type=script&lang=ts"
export * from "./EventsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__